import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./router";
import "./assets/main.css";
import axios from "axios";
import { useAuthStore } from "@/stores/authStore";
import { refreshToken } from "@/services/authServices";
import "@/assets/js/theme.js";
import "swiper/swiper-bundle.css";
import "aos/dist/aos.css";

import AOS from "aos";

router.afterEach(() => {
  AOS.init({
    once: true,
  });
  setTimeout(() => {
    window.init(); // Eğer init fonksiyonu varsa çağır
  }, 500);
});

axios.defaults.baseURL = process.env.VUE_APP_BASE_API_URL; // Base URL ayarlanıyor

// Axios isteklerine interceptor ile token ekleme
axios.interceptors.request.use((config) => {
  const authStore = useAuthStore();
  const token = authStore.token;

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const authStore = useAuthStore();

    if (error.response && error.response.status === 401) {
      // Eğer token süresi dolduysa refresh token al
      const newToken = await refreshToken();

      if (newToken) {
        error.config.headers.Authorization = `Bearer ${newToken}`;
        return axios(error.config);
      } else {
        authStore.clearAuthData();
        router.push("/auth/signin");
      }
    }

    return Promise.reject(error);
  }
);

const app = createApp(App);

app.use(createPinia()); // Pinia ekleniyor
app.use(router);

app.mount("#app");
